module.exports = __webpack_public_path__ + "img/icon_rhythm_gray.f49be9a3.svg";